import { useBreakpoint } from '@vivaldis/antd-ui'
import { PropsWithChildren } from 'react'
import { createElement } from '@vivaldis/common'
import styled from '@emotion/styled'
import { useIsInsideDetail } from '../../MasterDetail/MasterDetail/providers/DetailProvider'
import { Screen } from '../index'
import { ScreenEmptyStateProps } from '../typings/ScreenEmptyStateProps'

export const EmptyState = ({
  EmptyStateComponent,
  navigationBar,
  title,
  titleAccessory
}: ScreenEmptyStateProps) => {
  return (
    <>
      <Screen
        navigationBar={navigationBar}
        title={title}
        titleAccessory={titleAccessory}
        Component={Container}
      >
        {createElement(EmptyStateComponent)}
      </Screen>
    </>
  )
}

export const Container = ({
  children,
  offsetY
}: PropsWithChildren<{ offsetY: number }>) => {
  const isInsideDetail = useIsInsideDetail()
  const breakpoint = useBreakpoint()
  return (
    <ContainerBase masterOffset={isInsideDetail && breakpoint.lg}>
      <Wrapper offsetY={offsetY}>{children}</Wrapper>
    </ContainerBase>
  )
}

const ContainerBase = styled('div')<{ masterOffset: boolean }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  overflow: hidden;
  ${({ masterOffset }) => (masterOffset ? `left: 336px;` : '')};
`

const Wrapper = styled('div')<{ offsetY: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  ${({ offsetY }) =>
    typeof offsetY === 'number' ? `transform: translateY(${offsetY}px)` : ''};
`
